<template>
  <form-builder-editor-field
    :item="item"
    :show-hide-in-reports="true"
    :show-hide-in-preview="true"
    :lock-hide-in-preview="true"
    v-on="$listeners"
  >
    <form-builder-shared-form-preview
      v-if="item.type === 'shared-form-preview'"
      v-on:update="item = $event"
      :loading="false"
      :field-data="item"
      :form-id="id"
    />
  </form-builder-editor-field>
</template>

<script>
import FormBuilderSharedFormPreview from "../atoms/FormBuilderSharedFormPreview";
import FormBuilderEditorField from "./FormBuilderEditorField";

export default {
  components: {FormBuilderEditorField, FormBuilderSharedFormPreview},

  props: {
    item: {
      type: Object,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },

  setup() {
    // TODO: unify this with FormBuilderSharedFormPreview
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// FormBuilderEditorSharedFormPreview.vue?8835b556